import {motion, useReducedMotion} from 'motion/react';
import type {ReactNode} from 'react';

/** Entrada on-scroll: fade + rise corto, ease-out exponencial. */
export function Reveal({children, delay = 0, className}: {children: ReactNode; delay?: number; className?: string}) {
  const reduced = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduced ? false : {opacity: 0, y: 24}}
      whileInView={{opacity: 1, y: 0}}
      viewport={{once: true, margin: '-80px'}}
      transition={{duration: 0.7, delay, ease: [0.16, 1, 0.3, 1]}}
    >
      {children}
    </motion.div>
  );
}
